// Copyright (c) 2023 Ryan Piaskowy. All Rights Reserved.
import React from "react";

const TAG_BADGES = {
  "Staff Pick": { label: "★ Staff Pick", className: "badge-staff-pick" },
  "Event Feed": { label: "AI Event Feed", className: "badge-event-feed" },
};

// Renders an event flyer image with priority tag badges overlaid, and opens
// the amplified lightbox viewer on click. Orientation is left to the browser's
// native EXIF handling (image-orientation: from-image, see ImageCalendar.css)
// since manually re-applying the EXIF transform double-rotates already-corrected images.
function EventImage({ event, className, onView }) {
  const badges = (event.tags || [])
    .map((tag) => TAG_BADGES[tag])
    .filter(Boolean);

  return (
    <div className={`event-image-wrapper ${className || ""}`}>
      {badges.map((badge) => (
        <span key={badge.label} className={`priority-badge ${badge.className}`}>
          {badge.label}
        </span>
      ))}
      <img
        src={event.imageUrl}
        alt={event.eventTitle || "Event flyer"}
        className="scaled-image"
        onClick={(e) => {
          e.stopPropagation();
          onView(event);
        }}
      />
    </div>
  );
}

export default EventImage;
